<template lang="pug">
.data-usage.data-sage--categories(class="p-4 lg:p-0")
    .result-filter__info.w-full.mobile-only
        .list.flex.items-center.justify-between.mb-3.pb-3.border-b.border-dark
            strong Showing data
            div.btn-primary-o.btn-small(
                v-on:click="dataFilterShow = !dataFilterShow"
            ) Filter

        .list.flex.items-center.justify-between.mb-2
            span Limit data
            strong.monospace {{ filterSize }}

        .list.flex.items-center.justify-between.mb-2
            span Size
            strong.monospace {{ filterSort }}

        .list.flex.items-center.justify-between
            span Date time
            strong.monospace {{ filterDateRange.startDate | date}} - {{ filterDateRange.endDate  | date}}

    .result-filter__action(
        v-bind:class="{'is-show' : dataFilterShow}"
    )
        .mobile-only
            .header-filter.mb-4
                h2 Filter
                button(
                    v-on:click="dataFilterShow = !dataFilterShow"
                )
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        .flex.flex-wrap.mb-4
            .relative.mr-3  
                select.field-style(v-model="filterSize" @change="sizeAppsChange($event)" style="min-width:140px")
                    option(v-for="(size, index) in optSizeApps" :key="index" :value="size.value") {{ size.text }}
                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            .relative.mr-3
                    select.field-style(v-model="filterSort" style="min-width:140px")
                        option(v-for="(by, index) in optByApps" :key="index" :value="by.value") {{ by.text }}
                    .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            .relative.mr-3.field-date-time-picker
                date-range-picker(ref="picker" v-model="filterDateRange" @update="pickerUpdate($event)" :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }" :date-format="dateFormat" opens="right" autoApply=true :ranges='false')
                    div(slot="input" slot-scope="picker") {{ picker.startDate | date}} - {{ picker.endDate  | date}}
                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
            .flex.items-center.action-filter(class="-mx-1")
                .w-full.px-1(class="md:w-1/2")
                    button.btn-primary-o(
                        type="button" @click="filterChart()"
                        v-on:click="dataFilterShow = !dataFilterShow"
                    ) Apply
                .w-full.px-1(class="md:w-1/2")
                    button.btn-default(
                        type="button" @click="resetChart()"
                        v-on:click="dataFilterShow = !dataFilterShow"
                    ) Reset

    template(v-if="load_data_status_overall_app_usage.status === 'loading'")
        Loading(show="true")

    template(v-else)
        //- span(v-if='filterNull') No Data in Filter
        NoDataAvailable(v-if='filterNull')

        template(v-else-if="overall_app_usage.data_usage_cat && Object.keys(overall_app_usage.data_usage_cat).length > 0 && Object.keys(overall_app_usage.data_usage_cat.series).length > 0")
            highcharts(:options="chartOptions")
            //- highcharts(:options="chartOptions()")

        //- span(v-else) Data Not Found
        NoDataAvailable(v-else)

</template>

<script>
import { mapState } from 'vuex';
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'DataUsageCategories',
    components: {
        Loading,
        NoDataAvailable,
        DateRangePicker,
    },
    data() {
        return {
            title: '',
            chartType: 'bar',
            colorInputIsSupported: null,
            color: '#6fcd98',
            dataFilterShow: false,
            // filterDateRange: {
            //     startDate: localStorage.getItem('from_date'),
            //     endDate: localStorage.getItem('end_date')
            // },
            filterSize: 20,
            filterSort: 'desc',
            filterNull: false,
            optByApps: [
                {
                    value:'desc',
                    text:'Size Terbesar',
                }
            ],
            optSizeApps: [
                {
                    value:5,
                    text:'5 Aplikasi',
                },
                {
                    value:10,
                    text:'10 Aplikasi',
                },
                {
                    value:15,
                    text:'15 Aplikasi',
                },
                {
                    value:20,
                    text:'20 Aplikasi',
                },
            ],
            chartOptions: {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: null
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    title: {
                        text: null
                    }
                },
                yAxis: {
                    title: {
                        text: null
                    },
                },
                tooltip: {
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:1f}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series: [],
                credits: {
                    enabled: false
                },
            },
            dataCatCat: null,
            dataCatSeries: null
        }
    },
    computed: {
        ...mapState([
            'load_data_status_overall_app_usage',
            'overall_app_usage',
            'from_date_application_usage',
            'end_date_application_usage',
        ]),
        filterDateRange: {
            set() {},
            get() {
                return {
                    startDate: this.from_date_application_usage,
                    endDate: this.end_date_application_usage,
                };
            },
        },
    },
    watch: {
        overall_app_usage() {
            if (this.overall_app_usage.data_usage_cat && Object.keys(this.overall_app_usage.data_usage_cat).length > 0 && Object.keys(this.overall_app_usage.data_usage_cat.series).length > 0) {
                var totalApps = Object.keys(this.overall_app_usage.data_usage_cat.series).length;
                if (totalApps < this.filterSize) {
                    this.filterSize = parseInt(totalApps);
                } else {
                    this.filterSize = 20;
                }
                this.filterChart()
            }
        },
        filterDateRange() {},
    },
    methods: {
        dateFormat (classes, date) {
            // let start = localStorage.getItem('from_date')
            // let end = localStorage.getItem('end_date')
            // let startDate = new Date(start);
            // let endDate = new Date(end);
            let startDate = new Date(this.from_date_application_usage);
            let endDate = new Date(this.end_date_application_usage);
            if (!classes.disabled) {
              classes.disabled = date.getTime() < startDate.getTime() || date.getTime() > (endDate.getTime() + 86400000)
            }
            return classes
        },
        sizeAppsChange(e) {
            console.log(e.target.value)
        },
        pickerUpdate(e) {
            console.log(e)
        },
        avgArray(arr){
            var total = 0;
            for(var i = 0; i < arr.length; i++) {
                total += arr[i];
            }
            var avg = total / arr.length;
            return Math.round(avg)
        },
        compareAvg(arr, sort='desc'){
            return arr.slice().sort(function(a, b) {
                if (sort == 'desc') {
                    return b.data - a.data;
                } else {
                    return a.data - b.data;
                }
            });
        },
        resetChart(){
            // if (!confirm("Are you sure you want to reset Categories in Application Usage?")) {
            //     return;
            // }

            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset Categories in Application Usage?',
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    // this.filterDateRange.startDate = localStorage.getItem('from_date')
                    // this.filterDateRange.endDate = localStorage.getItem('end_date')
                    this.filterDateRange.startDate = this.from_date_application_usage
                    this.filterDateRange.endDate = this.end_date_application_usage
                    this.filterSort = 'desc'
                    this.filterSize = 20
                    this.filterChart()
                }
            });
        },
        filterChart(){
            // definition
            this.dataCatCat = Object.assign([], JSON.parse(JSON.stringify(this.overall_app_usage.data_usage_cat.categories)));
            this.dataCatSeries = Object.assign([], JSON.parse(JSON.stringify(this.overall_app_usage.data_usage_cat.series)));
            let startFilter = new Date(this.filterDateRange.startDate).setHours(0,0,0,0);
            let endFilter = new Date(this.filterDateRange.endDate).setHours(23,59,59,59);
            let count = [];
            var categoriesCatUsage = []
            var seriesNameCatUsage = 'Avg Data Usage by Categories'
            var seriesDataCatUsage = []
            var tmpDataCatUsage = []

            // filter by date
            // console.log('=====this.dataCatCat')
            // console.log(this.dataCatCat)
            this.dataCatCat = this.dataCatCat.filter((item, i) => {
                if (new Date(item).getTime() >= startFilter && new Date(item).getTime() <= endFilter) {
                    count.push(i)
                }
                // console.log(startFilter)
                // console.log(new Date(item).getTime())
                // console.log(endFilter)
                return new Date(item).getTime() >= startFilter &&
                       new Date(item).getTime() <= endFilter;

            });
            // console.log(this.dataCatCat)
            // console.log(this.dataCatCat.length)
            if (this.dataCatCat.length == 0) {
                this.filterNull=true
            } else {
                this.filterNull=false
            

                // filter data by date
                // console.log('=====this.dataCatSeries')
                // console.log(this.dataCatSeries)
                this.dataCatSeries = this.dataCatSeries.map((is) => {
                    let tmp = count.map((is2) => {
                                return is.data[is2];
                            })
                    is.data = tmp
                    return is
                });
                // console.log(this.dataCatSeries)
                
                // tmp data avg
                // console.log('=====this.tmpDataCatUsage')
                // console.log(tmpDataCatUsage)
                for (var i = 0; i < this.dataCatSeries.length; i++){ 
                    var tmpDAU = {
                        name: this.dataCatSeries[i].name,
                        data: this.avgArray(this.dataCatSeries[i].data)
                    }
                    tmpDataCatUsage.push(tmpDAU)
                }
                // console.log(tmpDataCatUsage)

                // sort by avg
                tmpDataCatUsage = this.compareAvg(tmpDataCatUsage, this.filterSort)
                // console.log('=====this.tmpDataCatUsage:sort')
                // console.log(tmpDataCatUsage)
                var loopJ = this.filterSize
                if (this.dataCatSeries.length < this.filterSize) {
                    loopJ = this.dataCatSeries.length
                }
                for (var j = 0; j < loopJ; j++){
                    categoriesCatUsage.push(tmpDataCatUsage[j].name)
                    seriesDataCatUsage.push(tmpDataCatUsage[j].data)
                }
                // console.log('=====this.categoriesCatUsage')
                // console.log(categoriesCatUsage)
                // console.log('=====this.seriesDataCatUsage')
                // console.log(seriesDataCatUsage)
                // console.log('=====this.seriesNameCatUsage')
                // console.log(seriesNameCatUsage)
                // update chart
                this.chartOptions.xAxis.categories = categoriesCatUsage;
                this.chartOptions.series = [{
                    data: seriesDataCatUsage,
                    name: seriesNameCatUsage,
                }];
            }
        }
    },
    mounted() {
        if (this.overall_app_usage.data_usage_cat && Object.keys(this.overall_app_usage.data_usage_cat).length > 0 && Object.keys(this.overall_app_usage.data_usage_cat.series).length > 0) {        
            this.filterChart()
        }
    },
    filters: {
      date: function (date) {
        return moment(date).format('YYYY-MM-DD');
      }
    }
}
</script>